import React from 'react';
import { Button, IconButton, Link, Stack, Typography } from '@mui/material';
import Iconify from 'components/iconify';

import { useNavigate } from 'react-router-dom';
import { paths } from 'routes/paths';

export const ClubFooter = props => {
  const {
    address,
    phone,
    email,
    instagram: igLink,
    facebook: fbLink,
    website: urlLink,
    whatsapp,
  } = props;
  const navigate = useNavigate();

  const urlEncodedWhatsapp = whatsapp?.replace(/[+{}-]/g, '').replace(/^0+/, '');

  const openApp = () => {
    localStorage.removeItem('selectedLanguage');

    navigate(paths.signup);
  };

  return (
    <Stack
      alignItems="center"
      spacing={1}
      sx={{
        backgroundColor: '#202020',
        color: '#fff',
        mt: 8,
        mb: -16,
        p: 4,
        pt: 1,
      }}
    >
      <Stack spacing={6} alignItems="center">
        <Stack spacing={1} alignItems="center">
          {/* social links */}
          {(igLink || fbLink || urlLink || whatsapp) && (
            <Stack spacing={2} direction="row" alignItems="center">
              {igLink && (
                <IconButton color="inherit" aria-label="instagram" href={igLink}>
                  <Iconify icon="carbon:logo-instagram" width={26} height={26} />
                </IconButton>
              )}
              {fbLink && (
                <IconButton color="inherit" aria-label="facebook" href={fbLink}>
                  <Iconify icon="carbon:logo-facebook" width={26} height={26} />
                </IconButton>
              )}
              {urlLink && (
                <IconButton color="inherit" aria-label="site" href={urlLink} target="_blank">
                  <Iconify icon="gg:website" width={26} height={26} />
                </IconButton>
              )}
              {whatsapp && (
                <IconButton
                  color="inherit"
                  aria-label="site"
                  href={'https://wa.me/' + urlEncodedWhatsapp}
                >
                  <Iconify icon="ic:baseline-whatsapp" width={26} height={26} />
                </IconButton>
              )}
            </Stack>
          )}

          {/* contacts */}
          {(address || email || phone) && (
            <Stack
              spacing={1}
              alignItems="center"
              sx={{ color: 'rgba(255, 255, 255, 0.43)', whiteSpace: 'break-spaces' }}
            >
              {address && (
                <Link color="inherit" href={'http://maps.apple.com/?q=' + address}>
                  {address}
                </Link>
              )}
              {email && (
                <Link color="inherit" href={'mailto:' + email}>
                  {email}
                </Link>
              )}
              {phone && (
                <Link color="inherit" href={'tel:' + phone}>
                  {phone}
                </Link>
              )}
            </Stack>
          )}
        </Stack>

        <Stack spacing={1} alignItems="center">
          <Typography
            variant="overline"
            sx={{ color: 'rgba(255, 255, 255, 0.43)', letterSpacing: '2px' }}
          >
            POWERED BY
          </Typography>
          <img
            src={`${import.meta.env.VITE_S3_URL}/assets/images/logo-vertical-g.svg`}
            alt="logo"
            style={{
              objectFit: 'contain',
              placeSelf: 'center',
              maxWidth: '70px',
            }}
          />
        </Stack>

        <Stack spacing={1} alignItems="center" sx={{ textAlign: 'center' }}>
          <Typography variant="h3">Hai un'attività?</Typography>
          <Typography variant="body1" paragraph>
            Gestisci tutti i tuoi menù direttamente dal tuo smartphone o tablet.
          </Typography>
          <Button variant="contained" size="large" onClick={openApp}>
            Scopri di più su AirDrink
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
};
